import {
  ReportBuilderFlowType,
  useInReportBuilderFlowType,
} from '../../hooks/useInReportBuilderFlowType';
import { CustomReportsEntityConfigurations } from './custom-reports/custom-reports-entity-configurations';
import { MwEntityConfiguration } from './mw-reports/mw-entity-configuration';

export const EntityConfiguration = () => {
  const reportBuilderFlowType = useInReportBuilderFlowType();

  return (
    <>
      {reportBuilderFlowType === ReportBuilderFlowType.MiddlewareReports && (
        <MwEntityConfiguration />
      )}
      {reportBuilderFlowType === ReportBuilderFlowType.CustomReports && (
        <CustomReportsEntityConfigurations />
      )}
    </>
  );
};
